import { createRouter, createWebHistory } from 'vue-router';
import Account from '../views/Account.vue';
import Activity from '../views/Activity.vue';
import Home from '../views/Home.vue';
import Landing from '../views/Landing.vue';
import Results from '../views/Results.vue';
import Simulation from '../views/Simulation.vue';
import Terms from '../views/Terms.vue';

// Setup Router
const setup = (iam, newRoutes) => {
  /* Route Level Code-Splitting
 *
 * this generates a separate chunk (about.[hash].js) for this route
 * which is lazy-loaded when the route is visited.
 *   component: () => import( '../views/About.vue'),
 * Results in a webpack chunk with `webpackChunkName: "about"`.
 */

  const routes = [
    {
      path: '/',
      name: 'landing',
      component: Landing,
      meta: {
        fullPage: true,
      },
    },
    {
      path: '/account',
      name: 'account',
      component: Account,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/jobs',
      name: 'activity',
      component: Activity,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/register',
      name: 'register',
      component: Landing,
      meta: {
        fullPage: true,
        registrationFlow: true,
      },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/jobs/new',
      name: 'simulation',
      component: Simulation,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/jobs/:id',
      name: 'job',
      component: Results,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
    },
    ...newRoutes,
  ];

  const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
  });

  // !store.state.iam.user or !store.getters['iam/isAuth']
  router.beforeEach((to, from, next) => {
    // only available during E2E tests
    if (window.Cypress) {
      next();
    } else {
      const validUser = iam.checkUser();
      const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
      if (requiresAuth && !validUser) {
        next('/');
      } else {
        next();
      }
    }
  });

  return router;
};

export default { setup };
